<template>
  <h1>{{ title }}</h1>
</template>
<script>
export default {
  data() {
    return {
      title: "Calculator App Using Vue.js",
    };
  },
};
</script>
<style scoped>
h1 {
  color: #fff;
}
</style>
